import(/* webpackMode: "eager" */ "/usr/src/app/apps/littau/components/gallery-slider/GallerySlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroImage"] */ "/usr/src/app/apps/littau/components/hero/HeroImage.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/littau/components/hero/HeroMain.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/littau/components/list-items/ListItems.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/littau/components/pre-intro/PreIntro.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/littau/components/room-grid/RoomShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/littau/components/slider-items/SliderItems.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/usr/src/app/apps/littau/lib/i18n-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/usr/src/app/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
